import React from 'react';
import { Space, Tag } from 'antd';
import { capitalize, isISOString } from '@/utils';
import dayjs from 'dayjs';

type Props = {
  filterTags: Record<string, any>;
  onClearFilterValue?: (value: any) => void;
};

const Index: React.FC<Props> = ({ filterTags, onClearFilterValue }) => {
  const tags = Object.entries(filterTags)
    .filter(([, value]) => !!value)
    .map(([key, value]) => ({ key, value }));

  const onClose = (key: string) => {
    onClearFilterValue?.(key);
  };

  const renderTagValue = (value: string) => {
    if (isISOString(value)) {
      return dayjs(value).format('MM/DD/YYYY');
    }
    return capitalize(value);
  };

  return (
    <Space size={[0, 'small']} wrap>
      {tags.map((tag) => (
        <Tag
          closable
          onClose={() => onClose(tag.key)}
          key={tag.key}
          color="cyan"
          style={{ borderRadius: '8px', padding: '5px' }}
        >
          {renderTagValue(tag.value)}
        </Tag>
      ))}
    </Space>
  );
};

export default Index;
